// add Optimizely feature flags here as enums

export enum PdpBreadcrumbs {
  NAME = 'pdp_breadcrumbs',

  Taxonomy = 'taxonomy',
}

// export {}; // allow empty file without error, remove when adding feature flags
